<div class="top-bar">

  <!-- Project (chatbot) switcher, on the left -->
  <button
    type="button"
    class="switcher"
    data-tour="project-switcher"
    [matMenuTriggerFor]="projectMenu"
    [attr.aria-label]="switcherAriaLabel"
    [matTooltip]="activeProjectName"
    matTooltipPosition="below">
    <nubo-avatar [name]="activeProjectName" size="md"></nubo-avatar>
    <span class="switcher-text">
      <span class="switcher-label">Project</span>
      <span class="switcher-name">{{ activeProjectName }}</span>
    </span>
    <mat-icon class="switcher-caret" aria-hidden="true">expand_more</mat-icon>
  </button>

  <!-- `class` is MatMenu's public name for its panelClass input (declared as
       `panelClass: ["class", "panelClass"]`). A `panelClass` attribute here is
       silently ignored, which left every rule nested under .nubo-menu dead. -->
  <mat-menu #projectMenu="matMenu" class="nubo-menu">
    <div class="nubo-menu-header">
      <span>Projects</span>
      <span class="nubo-menu-count">{{ projectCountLabel }}</span>
    </div>

    <!-- No <mat-icon> in these rows on purpose: mat-menu-item projects every
         mat-icon into its *leading* slot whatever the markup order, so a trailing
         check jumps to the front and shunts the avatar and name out of line with
         the rows above it. The check is an inline SVG for that reason. -->
    <button
      mat-menu-item
      class="menu-project"
      *ngFor="let p of projectContext.activeProjects; trackBy: trackByProjectId"
      [class.is-selected]="p.id === projectContext.activeProjectId"
      [attr.aria-current]="p.id === projectContext.activeProjectId ? 'true' : null"
      (click)="selectProject(p.id)">
      <nubo-avatar [name]="p.name" size="sm"></nubo-avatar>
      <span class="menu-project-name">{{ p.name }}</span>
      <svg
        *ngIf="p.id === projectContext.activeProjectId"
        class="menu-check"
        viewBox="0 0 24 24"
        width="16"
        height="16"
        aria-hidden="true">
        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill="currentColor" />
      </svg>
    </button>

    <hr class="nubo-menu-divider" />

    <button mat-menu-item (click)="openNewProject()" [disabled]="!canCreateProject">
      <mat-icon>add</mat-icon>
      <span>New project</span>
    </button>

    <p *ngIf="!canCreateProject" class="nubo-menu-hint">
      <mat-icon class="nubo-menu-hint-icon" aria-hidden="true">lock</mat-icon>
      <span>You are at your plan's project limit. Upgrade to add more agents.</span>
    </p>

    <button mat-menu-item (click)="openManage()">
      <mat-icon>tune</mat-icon>
      <span>Manage projects</span>
    </button>
  </mat-menu>

  <span class="spacer"></span>

  <button
    type="button"
    class="bar-action"
    (click)="toggleTheme()"
    [matTooltip]="themeTooltip"
    matTooltipPosition="below"
    [attr.aria-label]="themeTooltip">
    <mat-icon>{{ themeIcon }}</mat-icon>
  </button>

  <button
    type="button"
    class="account"
    [matMenuTriggerFor]="accountMenu"
    [attr.aria-label]="accountAriaLabel">
    <nubo-avatar [name]="userName" size="md" shape="circle"></nubo-avatar>
  </button>

  <mat-menu #accountMenu="matMenu" class="nubo-menu">
    <div class="nubo-menu-identity">
      <nubo-avatar [name]="userName" size="lg" shape="circle"></nubo-avatar>
      <span class="nubo-menu-identity-text">
        <span class="nubo-menu-identity-name">{{ userName }}</span>
        <span class="nubo-menu-identity-email">{{ userEmail }}</span>
      </span>
    </div>

    <button mat-menu-item (click)="goToProfile()">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>

    <hr class="nubo-menu-divider" />

    <button mat-menu-item class="is-danger" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Sign out</span>
    </button>
  </mat-menu>
</div>
